/* generated by tpl.py, DO NOT edit */
/* jshint -W004 */
/* jshint -W053 */
/* global exports */
/* exported tpl__bottomTag */
function tpl__bottomTag(tags) {
    var __out = '<div class="mi-detail__bottom-tag"><div class="mi-detail__bottom-tag-container">';
    var __arr1 = tags;
    var tag, idx = -1, __l1 = __arr1.length - 1;
    while (idx < __l1) {
        tag = __arr1[++idx];
        __out += '<a href="https://hot.browser.miui.com/v7/#page=search-list&query=' + tag + '" class="mi-detail__bottom-tag-link mi-detail__track" data-index="' + (idx + 1) + '" data-tag="' + tag + '"><span class="mi-detail__bottom-symbol">#</span>' + tag + "</a>";
    }
    __out += "</div></div>";
    return __out;
}

exports.tpl__bottomTag = tpl__bottomTag;
